import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { PopupService } from 'src/app/services';
import { SnippetManagerData } from '../snippet-manager/snippet-manager-data';
import { SnippetManagerComponent } from '../snippet-manager/snippet-manager.component';
import { IValueTemplate, ValueTemplateService } from 'src/app/xena-api';

@Component({
    selector: 'app-snippet',
    templateUrl: './snippet.component.html',
    styleUrls: ['./snippet.component.scss'],
    standalone: false
})
export class SnippetComponent implements OnInit {
  @Input() key: string;
  @Input() keyTitle: string;
  @Input() multilines: string;
  @Output() valueChange = new EventEmitter<string>();

  snippets: IValueTemplate[] = [];
  showIsLoading = false;
  isLoading = false;
  hasLoaded = false;

  constructor(private valueTemplateService: ValueTemplateService,
    private popupService: PopupService) { }

  ngOnInit(): void {
    if (!this.key) { throw new Error($localize`:@@snippetNoKeyError:No snippet key available for snippet-component (xwc).`); }
  }

  setSnippet(snippet: IValueTemplate): void {
    this.valueChange.emit(snippet?.content);
  }

  openManageSnippets(): void {
    const data: SnippetManagerData = { key: this.key, keyTitle: this.keyTitle, multiLines: this.isMultiline() };
    this.popupService.open(SnippetManagerComponent, $localize`:@@snippetPopupTitle:Snippets for ${this.keyTitle ?? this.key}`, data);

    this.snippets = [];
    this.hasLoaded = false;
  }

  loadSnippets(): void {
    if (this.isLoading || this.hasLoaded) { return; }

    this.isLoading = true;
    setTimeout(() => { // If it takes more than 200ms to load, show loading icon.
      if (this.isLoading) { this.showIsLoading = true; }
    }, 200);

    this.valueTemplateService.list({ key: this.key, forceNoPaging: true }).subscribe(result => {
      this.isLoading = false;
      this.hasLoaded = true;
      this.snippets = result.entities;
      this.showIsLoading = false;
    });
  }

  formatSnippetContent(content: string): string {
    content = content || '';
    if (content.length > 30) {
      return content.slice(0, 27) + '...';
    }
    return content;
  }

  isMultiline(): boolean {
    if (!this.multilines) { return false; }
    return this.multilines.toLocaleLowerCase() === 'true';
  }
}
